import { FunctionComponent, memo } from "react";
import { IProps } from "./translation-button.types";
import { Button, Tooltip } from "@edgetier/components";
import "./translation-button.scss";

/**
 * Button component used to translate sentences / messages
 * @param props.isTranslated   Boolean flag, checking if a translation was made
 * @param props.textLanguage   Language for the current sentence
 * @param props.userLanguage   User's language
 * @param props.onClick
 */
const TranslationButton: FunctionComponent<IProps> = ({ userLanguage, textLanguage, isTranslated, onClick }) => {
    // Different tooltip content when the phrase trigger is translated
    const tooltipContent = !isTranslated
        ? `Translate to ${userLanguage.language}`
        : `See original language (translated from ${userLanguage.language} to ${textLanguage.language})`;

    return (
        <Tooltip content={tooltipContent} useArrow>
            <div onClick={(event) => event.stopPropagation()} className="translation-button">
                <Button styleName={!isTranslated ? "grey" : "primary"} onClick={onClick} type="button">
                    {!isTranslated ? textLanguage.languageIsoCode : userLanguage.languageIsoCode}
                </Button>
            </div>
        </Tooltip>
    );
};

export default memo(TranslationButton);
